import React from "react";
import { EyeOff } from "lucide-react";

/** Shown to signed-in staff when they preview something that is switched off for visitors. */
export const OffPreviewBanner = ({ label = "This page" }) => (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-orange-500 text-black px-4 py-2 flex items-center justify-center gap-2"
        data-testid="off-preview-banner">
        <EyeOff className="w-4 h-4" />
        <span className="mono text-[10px] md:text-xs tracking-[0.16em] uppercase font-bold">
            OFF — {label} is hidden from visitors. Staff preview only.
        </span>
    </div>
);

export default OffPreviewBanner;
